<nav>
  @if (isLoading) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  }
  <div class="nav">
    <div class="nav-list">
      <button mat-button routerLink="/">Home</button>
      <button mat-button [matMenuTriggerFor]="menu">Forum</button>
      <mat-menu #menu="matMenu">
        @for (forum of forums; track forum) {
          <button mat-menu-item [routerLink]="['/forum', forum.id]">
            {{ forum.name }}
          </button>
        }
      </mat-menu>
    </div>
    @if (!isSignedIn) {
      <div class="nav-list">
        <button mat-button routerLink="/sign-in" (click)="signIn()">Sign in</button>
      </div>
    }
    @if (isSignedIn && currentUser) {
      <div class="nav-list">
        <button mat-button [routerLink]="['/profile', currentUser.username]" class="profile">
          <div class="profile-content">
            <app-avatar [image]="currentUser.avatarImage"></app-avatar>
            {{ currentUser.name || currentUser.username }}
          </div>
        </button>
        <div class="point">
          <app-user-economy [amount]="currentUser.points"></app-user-economy>
        </div>
        <button mat-button [matMenuTriggerFor]="menu">
          <i class="material-icons menu">menu</i>
          <i class="material-icons arrow">arrow_drop_down</i>
        </button>
        <mat-menu #menu="matMenu">
          <button mat-menu-item [routerLink]="['/profile', currentUser.username]">Profile</button>
          <button mat-menu-item routerLink="/user/settings">Settings</button>
          <button mat-menu-item (click)="signOut()">Sign out</button>
        </mat-menu>
      </div>
    }
  </div>
</nav>
